import { useState } from "react";
import { IOrder } from "../interface/IOrder";
import { getOrderListRoute } from "@api-routes/bff";
import { useFetch } from "@common/hook/useFetch";
import { EORDER_STATUS } from "@constants";
import { objectToQueryQuestionMark } from "@utils/url";
import { getResponseToState, IOrderResponse } from "@features/Order/mappers/getOrderListMapper";

export const useOrderList = () => {
    const [orderList, setOrderList] = useState<IOrder[]>([]);
    const [getOrdersState, { get }] = useFetch();

    const getOrders = (startDateTime?: string) => {
        const params = {
            startDateTime: startDateTime ?? "2018-01-07T19:24:58.730Z",
            statuses: startDateTime
                ? [EORDER_STATUS.CANCELLED.toUpperCase(), EORDER_STATUS.COMPLETED.toUpperCase()]
                : [EORDER_STATUS.IN_PROGRESS.replace(" ", "_").toUpperCase()],
            salesType: "B2C",
        };

        get<IOrderResponse[]>(getOrderListRoute(objectToQueryQuestionMark(params))).then((orderListResponse) => {
            if (orderListResponse) {
                setOrderList(getResponseToState(orderListResponse));
            }
        });
    };

    return { orderList, getOrdersState, getOrders };
};
